import { validateEmail } from "../../../utils/commonFunctions/ValidateEmail";
import { ButtonCust } from "../../widgets";
import EnvConfig from "../../../config/env.config.json";
import {
  Box,
  Grid,
  TextField,
  Theme,
  ThemeProvider,
  createTheme,
  outlinedInputClasses,
  useTheme,
} from "@mui/material";
import { LeadGenProps } from "./LeadGeneration";
import { BrandNameUpdate } from "../../../utils/commonFunctions/BrandNameUpdate";
import { updateSvgFillColor } from "../../../utils/commonFunctions/ReusableFunctions";

const customTheme = (outerTheme: Theme) =>
  createTheme({
    palette: {
      mode: outerTheme.palette.mode,
    },
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              color: "var(--text_color)",
            },
            "& .MuiInputBase-root": {
              color: "var(--text_field_text)",
              background: "var(--white)",
            },
            "& .MuiInputLabel-root": {
              color: "var(--text_field_text)",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          notchedOutline: {
            borderColor: "var(--primary_brand_color)",
          },
          root: {
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "var(--primary_brand_color)",
              border: "1px solid var(--primary_brand_color)",
            },
            [`&.Mui-focused .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: "var(--primary_brand_color)",
            },
          },
        },
      },
    },
  });

const T7LeadGenerationComponent = (props: LeadGenProps) => {
  const outerTheme = useTheme();
  const {
    bg_web,
    bg_mweb,
    heading,
    sub_heading,
    place_holder,
    btn_txt,
    success_text,
    intouch_text,
    svgCode,
  } = props.leadContent || {};

  return (
    <Box
      sx={{
        pt: "20px",
        pb: "10px",
        backgroundColor: "var(--lead_generation_bg_color)",
        // background: {
        //   xs: `url(${bg_mweb?.data?.attributes?.url})`,
        //   sm: `url(${bg_web?.data?.attributes?.url})`,
        // },
        backgroundSize: "cover !important",
      }}
    >
      <Grid container xs={12}>
        <Grid
          item
          container
          xs={12}
          md={8}
          sx={{
            px: 2,
            py: { xs: 0.5, md: 2 },
            display: "flex",
            justifyContent: { xs: "center", md: "start" },
            alignItems: { xs: "center", md: "start" },
          }}
        >
          <Grid
            container
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: { xs: "center", md: "unset" },
              py: { xs: "", md: 8.75 },
              px: { xs: "15px", md: "55px" },
            }}
          >
            <Box
              data-testid="title"
              sx={{
                fontSize: { xs: "26px", md: "30px" },
                fontFamily: {
                  xs: "var(--font_family_Bold)",
                },
                fontWeight: "var(--font_weight_4)",
                lineHeight: { md: "50px" },
                color: "var(--black)",
                mb: { xs: "15px", md: "20px" },
              }}
            >
              {BrandNameUpdate(heading)}
            </Box>
            <Box
              sx={{
                fontSize: { xs: "14px", md: "18px" },
                fontFamily: {
                  xs: "var(--font_family_Medium)",
                  sm: "var(--font_family_Medium)",
                },
                color: "var(--black)",
                mb: { xs: "15px", md: "30px" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {BrandNameUpdate(sub_heading)}
            </Box>
            {props.emailSharedCoverage ? (
              <>
                <Grid
                  container
                  xs={props.leadContent?.success_emoji ? 12 : 11}
                  // sm={6}
                  // md={props.leadContent?.success_emoji ? 5 : 4.5}
                  // lg={props.leadContent?.success_emoji ? 5 : 4}
                  // xl={props.leadContent?.success_emoji ? 5 : 4}
                  sx={{
                    display: "flex",
                    flexDirection: props.leadContent?.success_emoji
                      ? "row"
                      : "column",
                    justifyContent: props.leadContent?.success_emoji
                      ? "flex-start"
                      : "center",
                    alignItems: props.leadContent?.success_emoji
                      ? "center"
                      : "flex-start",
                    marginLeft: {
                      xs: "0px",
                      sm: props.leadContent?.success_emoji ? "0px" : "20px",
                    },
                  }}
                >
                  {props.leadContent?.success_emoji ? (
                    <Box
                      component={"span"}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        component={"img"}
                        width="25px"
                        height="25px"
                        alt={
                          props.leadContent?.success_emoji?.data?.attributes
                            ?.alternativeText || ""
                        }
                        src={
                          props.leadContent?.success_emoji?.data?.attributes
                            ?.url || ""
                        }
                        sx={{ mr: "20px" }}
                      ></Box>
                      <Box
                        component={"span"}
                        sx={{
                          display: "flex",
                          justifyContent: props.leadContent?.success_emoji
                            ? "flex-start"
                            : "center",
                          alignItems: "center",
                          fontSize: "18px",
                          color: "var(--black)",
                        }}
                      >
                        {`${success_text} ${intouch_text}`}
                      </Box>
                    </Box>
                  ) : null}
                </Grid>
              </>
            ) : (
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: { xs: "flex-start", md: "unset" },
                  flexDirection: "row",
                  mb: { xs: "10px", md: "30px" },
                  mt: { xs: "10px", md: "0" },
                }}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter") {
                    props.submitHandler(e);
                  }
                }}
              >
                <Grid
                  sx={{
                    mb: { md: 0 },
                    width: { xs: "70%", sm: "442px" },
                  }}
                >
                  <ThemeProvider theme={customTheme(outerTheme)}>
                    <TextField
                      InputProps={{
                        sx: {
                          borderRadius: "30px 0px 0px 30px",
                          height: { xs: "38px", md: "unset" },
                        },
                      }}
                      variant="outlined"
                      value={props.email}
                      placeholder={place_holder}
                      onChange={props.emailHandler}
                      sx={{
                        input: {
                          color: "var(--text_color) !important",
                          fontFamily: "var(--font_family_Regular)",
                          padding: { xs: "10px 12px", sm: "19px 20px" },
                          fontSize: { xs: "12px", sm: "14px" },
                          "&::placeholder": {
                            opacity: 1,
                            fontWeight: 400,
                            lineHeight: "25px",
                            textAlign: "left",
                            fontSize: {
                              xs: "12px !important",
                              sm: "14px !important",
                            },
                          },
                        },
                        width: { xs: "100%", md: "100%" },
                        borderRadius: "30px 0px 0px 30px",
                        color: "white",
                      }}
                      error={
                        (props.email.length >= 1 &&
                          !validateEmail(props.email)) ||
                        (props.submitBtnClick && !props.email) ||
                        (props.submitBtnClick &&
                          props.email !== "" &&
                          !validateEmail(props.email))
                      }
                      helperText={
                        (props.email.length >= 1 || props.submitBtnClick) &&
                        props.helperTextHandler()
                      }
                    />
                  </ThemeProvider>
                </Grid>
                <Grid sx={{ width: { xs: "30%", sm: "unset" } }}>
                  <ButtonCust
                    variantType={EnvConfig.PRIMARY_BUTTON_TYPE}
                    onClick={(e: any) => props.submitHandler(e)}
                    loading={props.submitClick}
                    sx={{
                      fontSize: {
                        xs: "14px !important",
                        sm: "16px !important",
                      },
                      py: { md: "27px" },
                      borderRadius: "0 30px 30px 0 !important",
                      minWidth: {
                        xs: "100% !important",
                        md: "200px !important",
                      },
                      height: { xs: "38px !important", md: "58px !important" },
                    }}
                  >
                    {btn_txt}
                  </ButtonCust>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: { md: "0px 57px" },
          }}
        >
          <Box
            component="div"
            sx={{
              "& svg": {
                height: { xs: "180px", md: "380px" },
                maxWidth: { xs: "335px", md: "516px" },
                marginLeft: { xs: "0px", md: "-150px" },
              },
            }}
            dangerouslySetInnerHTML={{
              __html: updateSvgFillColor(svgCode, "var(--primary_color)"),
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default T7LeadGenerationComponent;
